import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from 'moment';
import 'moment/locale/pt-br'
import api from "../../services/api.js";
import Logo from "../../assets/cl_logo.png"
import "../aniversario-franquias-mobile/aniversario-franquias-mobile.css";
import { dadosLogin } from "../../zustand/zuztand.js"

function AniversarioFranquiasMobile() {

  const navigate = useNavigate();
  const { ifLogado, usuario, nivel_user } = dadosLogin()

  const local = moment().locale('pt-br').format('LL'); //converte a data par pt-br   ex: 12 de setembro de 2024 
  const mesAtuals = (local.split(" ")[2]); // converte 12 de setembro de 2024  em array e pega o indice 2 (mes extenço)
  const [dados, setDados] = useState([]);
  const [cadastros, setCadastros] = useState([]);  

  useEffect(() => {

    var mes = new Date();
    var month = mes.getMonth();
    var mesAtual = month + 1;
    let novo_array = [];

    api.get("/franquia_aniver_listar")
      .then((resp) => {
        //console.log(resp.data)
        resp.data.map((item) => {
          let dtaAniver = parseInt(item.data_inalg.substring(3, 5));

          if (dtaAniver === mesAtual) {
            novo_array.push({
              id: item.id_franquia,
              empresa: item.razao_franquia,           
              apelido: item.nome_franquia,
              data: item.data_inalg,
              localizacao: item.cidade_franquia,
              logo: item.img_franquia,
              uf: item.uf_franquia
            })
          }
        })
        console.log(novo_array)
        setCadastros(novo_array);
      })
      .catch((err) => {
        setCadastros([]);
        alert("Erro ao carregar dados");
      });

  }, []);

  function CadastroCard({ empresa, apelido, localizacao, data, logo, uf }){
    return <>
        <div className="card h-100 shadow-sm  ">
          <div className="card-body d-flex flex-column align-items-center p-3">
            <div className="logo-container mb-3">
              <img src={logo || "/api/placeholder/150/150"} alt={`Logo de ${empresa}`} className="img-fluid rounded-circle" />
            </div>
            <h6 className="card-title text-center fw-bold">{empresa}</h6>
            <div className="card-text text-center">
              <p className="mb-1 text-muted">
                <i className="bi bi-geo-alt me-1"></i>
                {apelido}- {uf}
              </p>
              <p className="text-muted small">
                <i className="bi bi-calendar me-1"></i>
                {data}
              </p>
            </div>
          </div>
        </div>
      </>
   
  };

  return (
    <>
      <div className="row d-flex mt-2 ms-2 me-2">
        <div className="d-flex justify-content-between ">
          <h4 className="text-white ">Aniversariantes: {mesAtuals}</h4>
          <Link to="/dashboard" className="btn btn-success btn-sm me-2 " >Voltar </Link>
        </div>
      </div>
      <div className="tela-card-fran">
        <div className="container py-4 ">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 ">
            {cadastros.map((item) => (
              <div className="col  " key={item.id}>
                <CadastroCard
                  empresa={item.empresa}
                  localizacao={item.localizacao}
                  apelido={item.apelido}
                  data={item.data}
                  logo={item.logo}
                  uf={item.uf}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default AniversarioFranquiasMobile;